import { ActiveFilter } from "../../crawler.interface";
import { JobDetailDataState } from "./jobDetail.interface";

export const JobDetailDefaultState: JobDetailDataState = {
    ResultCount: {
        Total: 0,
        Current: 0,
        Limit: 0,
        Offset: 0
    },
    loadedPages: [],
    filteredPages: [],
    sortInfo: {
        sortIndex: 1,
        activeColumn: '',
    },
    activeFilters: [],
    emptyResultsMessage: null,
    domainOptions: [],
    phraseOptions: [],
    isLoaded: false,
    isFilterRunning: false,
};

export const JobDetailDefaultFilters: ActiveFilter[] = [
    { name: 'page_type', value: 'any' }
];